<template>
  <div class="upgrade-equity-modal">
    <div class="upgrade-equity-modal__loading" v-if="globalLoading">
      <Loading :visible="globalLoading" />
    </div>
    <div
      :class="['upgrade-equity-modal__main-card', isUS() && 'upgrade-equity-modal__main-card--us']"
      v-else
    >
      <!-- 支付成功态 -->
      <div v-if="paySucceeded" class="upgrade-equity-modal__pay-success">
        <PaySuccess :title="paySuccessTitle" :desc="paySuccessDesc" />
        <div class="upgrade-equity-modal__pay-success-bar"></div>
        <PaySuccTip class="upgrade-equity-modal__pay-success-tip" />
      </div>
      <!-- 支付中/待选择套餐态 -->
      <div v-else class="upgrade-equity-modal__content">
        <!-- 授权类型说明与引导到企业套餐 -->
        <div class="upgrade-equity-modal__auth-type">
          <div
            class="upgrade-equity-modal__auth-type-title upgrade-equity-modal__auth-type-title--row"
          >
            {{ $t('ge-ren-shang-yong-shou-quan') }}
            <AuthorizationDifferences>
              <IconCircleWarning
                name="info-fill"
                class="upgrade-equity-modal__auth-type-info-icon"
              />
            </AuthorizationDifferences>
          </div>
          <div class="upgrade-equity-modal__auth-type-desc">
            {{ $t('jin-xian-ge-ren-shi-yong-bu-ke-yong-yu-qi-ye-shang-ye-huo-dong') }}
          </div>
          <div
            class="upgrade-equity-modal__auth-type-enterprise-btn"
            @click="handleBuyEnterprisePackage"
          >
            <span class="upgrade-equity-modal__auth-type-enterprise-text">{{
              $t('wo-yao-gou-mai-qi-ye-shang-yong-tao-can')
            }}</span>
            <IconArrow class="upgrade-equity-modal__auth-type-enterprise-arrow"></IconArrow>
          </div>
        </div>

        <!-- 升级权益列表 -->
        <div v-for="right in rights" :key="right.id" class="upgrade-equity-modal__upgrade-right">
          <div class="upgrade-equity-modal__upgrade-right-title">
            {{ right.rights_name }}
            <Link
              class="upgrade-equity-modal__upgrade-right-link standard"
              @click.stop="handleShowRightsDesc"
            >
              {{ $t('cha-kan-wan-zheng-quan-yi-dui-bi') }}
              <IconArrow class="upgrade-equity-modal__upgrade-right-link-arrow"></IconArrow>
            </Link>
          </div>
          <div class="upgrade-equity-modal__upgrade-right-fee-grid">
            <Fees
              v-for="f in displayFees"
              :key="f.id"
              :fees="f"
              :isUpgrade="true"
              :selected="f.id === currentFee?.id"
              :discount="undefined"
              @on-select="f => handleSelectFee(f, right)"
            />
          </div>
          <div class="upgrade-equity-modal__changed-benefits">
            <div class="upgrade-equity-modal__changed-benefits-title">
              {{ $t('sheng-ji-hou-quan-yi-bian-hua') }}
              <Tooltip
                trigger="hover"
                placement="top"
                :content-class="'upgrade-equity-modal__formula-tooltip'"
              >
                <template #default>
                  <div class="upgrade-equity-modal__changed-benefits-formula">
                    {{ $t('ji-suan-gong-shi') }}
                    <IconTip class="upgrade-equity-modal__changed-benefits-formula-tip" />
                  </div>
                </template>
                <template #content>
                  <div v-if="currentFee" class="upgrade-equity-modal__formula">
                    <div class="upgrade-equity-modal__formula-description">
                      {{ $t('tao-can-sheng-ji-cha-jia-ji-suan-gong-shi') }} = ({{
                        $t('sheng-ji-hou-tao-can-jia-ge')
                      }}
                      - {{ $t('dang-qian-tao-can-jia-ge') }}) x
                      <div class="upgrade-equity-modal__formula-fraction">
                        {{ $t('tao-can-sheng-yu-tian-shu') }}
                        <div class="upgrade-equity-modal__formula-divider"></div>
                        {{ $t('sheng-ji-hou-tao-can-tian-shu') }}
                      </div>
                    </div>
                    <div class="upgrade-equity-modal__formula-value">
                      {{ $t('dang-qian-tao-can-sheng-ji-cha-jia') }} = (
                      {{ currentFee!.upgrade_desc![0].to_rights_price / 100 }}
                      -
                      {{ currentFee!.upgrade_desc![0].from_rights_price / 100 }}
                      ) x
                      <div class="upgrade-equity-modal__formula-fraction">
                        {{ currentFee!.upgrade_desc![0].to_rights_remain_days }}
                        <div class="upgrade-equity-modal__formula-divider"></div>
                        {{ currentFee!.upgrade_desc![0].to_rights_days }}
                      </div>
                    </div>
                    <div class="upgrade-equity-modal__formula-description">
                      {{ $t('tao-can-sheng-ji-bu-fa-yan-bi-ji-suan-gong-shi') }} = ({{
                        $t('sheng-ji-hou-tao-can-yan-bi-shu-liang')
                      }}
                      - {{ $t('dang-qian-tao-can-yan-bi-shu-liang') }}) x
                      <div class="upgrade-equity-modal__formula-fraction">
                        {{ $t('tao-can-sheng-yu-tian-shu') }}
                        <div class="upgrade-equity-modal__formula-divider"></div>
                        {{ $t('sheng-ji-hou-tao-can-tian-shu') }}
                      </div>
                    </div>
                    <div class="upgrade-equity-modal__formula-value">
                      {{ $t('dang-qian-bu-fa-yan-bi') }} = ( {{ toCredit }} - {{ fromCredit }}
                      ) x
                      <div class="upgrade-equity-modal__formula-fraction">
                        {{ currentFee!.upgrade_desc![0].to_rights_remain_days }}
                        <div class="upgrade-equity-modal__formula-divider"></div>
                        {{ currentFee!.upgrade_desc![0].to_rights_days }}
                      </div>
                    </div>
                  </div>
                </template>
              </Tooltip>
            </div>
            <div class="upgrade-equity-modal__changed-benefits-content">
              <div class="upgrade-equity-modal__changed-benefits-item">
                <Img
                  :src="IconCoin"
                  class="upgrade-equity-modal__changed-benefits-item-icon"
                  :enable-oss="true"
                />
                <span>{{ $t('yan-bi') }}</span>
                <span
                  class="upgrade-equity-modal__changed-benefits-item-number upgrade-equity-modal__changed-benefits-item-number--credit"
                >
                  +{{ currentFee?.upgrade_desc?.[0]?.credit_coin }}
                </span>
              </div>
              <div class="upgrade-equity-modal__changed-benefits-item">
                <Img
                  :src="IconVideo"
                  class="upgrade-equity-modal__changed-benefits-item-icon"
                  :enable-oss="false"
                />
                {{ $t('dan-tiao-shi-pin-shang-xian') }}
                <span
                  class="upgrade-equity-modal__changed-benefits-item-number upgrade-equity-modal__changed-benefits-item-number--time"
                >
                  {{ fromTime }}
                </span>
                {{ $t('fen-zhong') }}
                <Img
                  class="upgrade-equity-modal__changed-benefits-item-arrow"
                  :src="getFeUrl('/assets/icon-upgrade.png')"
                />
                <span
                  class="upgrade-equity-modal__changed-benefits-item-number upgrade-equity-modal__changed-benefits-item-number--time"
                >
                  {{ toTime }}
                </span>
                {{ $t('fen-zhong') }}
              </div>
            </div>
          </div>
        </div>

        <div class="renew-tips">
          套餐权益将于 {{ expiredTime }} 到期，如需续费会员，可以进行
          <span class="renew-tips__link" @click="handleRenewPackage">套餐续费</span>
        </div>
      </div>
      <template v-if="!isUS()">
        <!-- 分隔线，仅在未支付成功时展示右侧二维码面板 -->
        <div v-if="!paySucceeded" class="upgrade-equity-modal__divider"></div>
        <!-- 右侧二维码面板：创建/轮询支付订单与咨询模块 -->
        <div
          v-if="order?.status === undefined && !isUS()"
          class="upgrade-equity-modal__right-panel"
        >
          <PayQrCode
            v-model:payType="currentPayType"
            v-model:agreementChecked="agreementAccepted"
            v-model:loading="isCreating"
            :buyType="currentFee?.buy_type"
            :qrcode="qrCode"
            :reorder="create"
            :behavior="ORDER_BEHAVIOR.UPGRADE"
            :priceText="currentFee?.upgrade_price || 0"
            :expiredDate="expiredDateRange"
          >
            <Consultant
              :rightType="currentRightType"
              :orderType="ORDER_TYPE.PACKAGE"
              @transfer="onTransferClick"
              :transferDisabled="false"
            />
          </PayQrCode>
        </div>
        <!-- 支付失败态（与上方条件成组，保持原逻辑不变） -->
        <PayFail v-else-if="!paySucceeded" @back="repay" />
      </template>
      <template v-else>
        <StripeOperation
          :url="raw?.vendor_redirect_url"
          :loading="isCreating"
          @payed="handlePaySucceeded"
        >
        </StripeOperation>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getOrderClientUpgradePrice } from '@rendora/common/entities/order';
import type { UseOrderInput } from '@rendora/common/features/payment/composables/types';
import useOrder from '@rendora/common/features/payment/composables/useOrder';
import { getI18nService } from '@rendora/common/services/i18n';
import { type IEquity, type IFees } from '@rendora/common/store/rights';
import { useUserStore } from '@rendora/common/store/user';
import {
  BUY_TYPE,
  IRightsType,
  ORDER_BEHAVIOR,
  ORDER_TYPE,
  PAY_TYPE,
} from '@rendora/common/types/enums';
import { isUS } from '@rendora/common/utils/config';
import { formatPrice } from '@rendora/common/utils/transform';
import { filterFeesBySubscription } from '../../constants';
import { getFeUrl } from '@rendora/common/utils/url';
import IconArrow from '@rendora/design/assets/arrow.svg?component';
import IconCircleWarning from '@rendora/design/assets/circle-warning.svg?component';
import { Img } from '@rendora/design/components/img/index';
import { Link } from '@rendora/design/components/link/index';
import { Loading } from '@rendora/design/components/loading/index';
import { Tooltip } from '@rendora/design/components/tooltip/index';
import dayjs from 'dayjs';
import { storeToRefs } from 'pinia';
import { computed, onMounted, ref, watch } from 'vue';
import AuthorizationDifferences from '../AuthorizationDifferences.vue';
import Consultant from '../Consultant.vue';
import PayFail from '../PayFail.vue';
import PayQrCode from '../PayQrCode.vue';
import PaySuccess from '../PaySuccess.vue';
import PaySuccTip from '../PaySuccessTip.vue';
import { showRightCompareModal } from '../right-compare/index';
import StripeOperation from '../StripeOperation.vue';
import Fees from './Fees.vue';

const i18nService = getI18nService();
const $t = i18nService.t;

import IconCoin from '@rendora/design/assets/color/credit.png';
import IconTip from '@rendora/design/assets/tips.svg?component';
import { showBuyEquityModal } from '../buy-equity';

const IconVideo = getFeUrl('/assets/video.png');

// 组件入参：默认权益类型（用于决定默认选中项）
const props = defineProps<{
  defaultRightsType: IRightsType;
}>();

// Store 初始化
const userStore = useUserStore();

// 响应式引用
const { user } = storeToRefs(userStore);

// 当前选中的费用方案和权益
const currentFee = ref<IFees | null>(null);
const currentRight = ref<IEquity | null>(null);
const rights = ref<IEquity[]>([]);

// 升级相关的计算属性
const fromTime = computed(() => {
  if (!currentFee.value) {
    return 0;
  }
  const t = currentFee.value?.upgrade_desc?.[0].from_single_video_max_duration;
  return t ? Math.ceil(t / 60) : 0;
});

const toTime = computed(() => {
  const t = currentFee.value?.upgrade_desc?.[0].to_single_video_max_duration;
  return t ? Math.ceil(t / 60) : 0;
});

const toCredit = computed(() => {
  const upgrade_desc = currentFee.value?.upgrade_desc?.[0];
  const v = upgrade_desc?.to_credit_coin;
  return v || 0;
});

const fromCredit = computed(() => {
  const upgrade_desc = currentFee.value?.upgrade_desc?.[0];
  const v = upgrade_desc?.from_credit_coin;
  return v || 0;
});

// 下单参数（根据当前选中的费用方案实时计算）
const orderBody = computed<UseOrderInput>(() => ({
  rightsId: currentFee.value?.id,
  timeIdentity: currentFee.value?.time_identity,
  buyType: currentFee.value?.buy_type ?? BUY_TYPE.PAYMENT,
  orderType: ORDER_TYPE.PACKAGE,
  rightsType: currentRight.value?.rights_type || props.defaultRightsType,
  behavior: ORDER_BEHAVIOR.UPGRADE,
}));

const expiredTime = computed(() => {
  return dayjs(user.value?.current_package_expired_time).format('YYYY.MM.DD');
});

// 支付成功的消息提示
const paySuccessTitle = computed(() => formatPrice(currentFee.value?.upgrade_price || 0).string);

const paySuccessDesc = computed(() => {
  const payAction = (() => {
    if (currentFee.value?.buy_type === BUY_TYPE.PAYMENT) {
      return currentFee.value.days === 30 ? $t('dan-yue') : $t('dan-nian');
    }
    return currentFee.value?.days === 30 ? $t('lian-xu-bao-yue') : $t('lian-xu-bao-nian');
  })();

  return `${currentRight.value?.rights_name} ${payAction}`;
});

// 支付相关状态与方法
const {
  paySucceeded,
  currentPayType,
  agreementAccepted,
  isCreating,
  qrCode,
  order,
  currentRightType,
  create,
  repay,
  setPayType,
  raw,
} = useOrder(orderBody);

// 展示的费用方案
const displayFees = computed(() => {
  return filterFeesBySubscription(currentRight.value?.rights_by_time || []);
});

// 到期日期范围
const expiredDateRange = computed(() => {
  const endDate = dayjs(user.value?.current_package_expired_time).format('YYYY.MM.DD');
  const beginDate = dayjs().format('YYYY.MM.DD');

  return `${beginDate}~${endDate}`;
});

// 加载态
const pending = ref(false);

// 全局 loading 状态：合并初始加载和创建订单的 loading
const globalLoading = computed(() => pending.value);

watch(
  currentFee,
  newVal => {
    if (newVal && newVal.buy_type === BUY_TYPE.SUBSCRIBE) {
      setPayType(PAY_TYPE.ALIPAY);
    }
  },
  { immediate: true },
);

onMounted(async () => {
  pending.value = true;
  try {
    const res = await getOrderClientUpgradePrice();
    if (res.data) {
      rights.value = res.data;
      currentRight.value = rights.value[0];
      currentFee.value = displayFees.value?.[0] || null;
    }
  } catch (err) {
    console.error(err);
  }
  pending.value = false;
});

// 选择费用卡片
function handleSelectFee(fee: IFees, right: IEquity) {
  currentRight.value = right;
  currentFee.value = fee;
}

// 转账拦截：主动触发重新下单（转为转账方式）
function onTransferClick() {
  create(true);
}

function handleBuyEnterprisePackage() {
  showRightCompareModal();
}

function handleRenewPackage() {
  showBuyEquityModal();
}

function handleShowRightsDesc() {
  showRightCompareModal();
}

function handlePaySucceeded() {
  location.reload();
}
</script>

<style>
.upgrade-equity-modal__formula-tooltip {
  max-width: 600px !important;
}
</style>

<style lang="scss" scoped>
.renew-tips {
  font-size: var(--x-text-12-size);
  line-height: var(--x-text-12-line-height);
  color: var(--x-text-1);
  .renew-tips__link {
    color: var(--x-warning-9);
    cursor: pointer;
    &:hover {
      color: var(--x-warning-8);
    }
  }
}

// 主容器
.upgrade-equity-modal {
  width: 100%;
  height: 100%;
  min-height: 498px;
  background: var(--x-white-1);
  display: flex;
  border-radius: var(--x-radius-large);
}

// 加载容器
.upgrade-equity-modal__loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

// 主卡片
.upgrade-equity-modal__main-card {
  flex: 1 1 0%;
  display: flex;
  justify-content: space-between;
  background: var(--x-back-1);
  border-radius: var(--x-radius-large);
}

.upgrade-equity-modal__main-card--us {
  flex-direction: column;
}

// 支付成功状态
.upgrade-equity-modal__pay-success {
  width: 100%;
}

.upgrade-equity-modal__pay-success-bar {
  width: 92%;
  margin: 0 auto;
  height: 1px;
  background: var(--x-back-3);
}

.upgrade-equity-modal__pay-success-tip {
  margin: 28px 0;
}

// 内容区域
.upgrade-equity-modal__content {
  display: flex;
  flex: 1 1 0%;
  flex-direction: column;
  max-width: 580px;
  gap: 28px;
  padding: 20px;
}

// 授权类型区域
.upgrade-equity-modal__auth-type {
  position: relative;
  width: 100%;
  padding-left: 10px;
}

.upgrade-equity-modal__auth-type-title {
  color: var(--x-warning-7);
  font-weight: 600;
  line-height: 20px;
}

.upgrade-equity-modal__auth-type-title--row {
  display: flex;
  align-items: center;
}

.upgrade-equity-modal__auth-type-desc {
  margin-top: 2px;
  color: var(--x-text-1);
  font-size: 12px;
  line-height: 20px;
}

.upgrade-equity-modal__auth-type-info-icon {
  margin-top: 4px;
  cursor: pointer;
  height: 12px;
  color: var(--x-black-5);
  margin-left: 4px;
}

.upgrade-equity-modal__auth-type-enterprise-btn {
  position: absolute;
  cursor: pointer;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 44px;
  border-radius: var(--x-radius-medium);
  color: var(--x-warning-10);
  background: var(--x-warning-3);
  padding: 12px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.upgrade-equity-modal__auth-type-enterprise-text {
  margin-right: 4px;
  font-weight: 600;
}

.upgrade-equity-modal__auth-type-enterprise-arrow {
  height: 16px;
}

// 升级权益区域
.upgrade-equity-modal__upgrade-right-title {
  font-size: 14px;
  color: var(--x-text-1);
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.upgrade-equity-modal__upgrade-right-link {
  margin-left: 8px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.upgrade-equity-modal__upgrade-right-link-arrow {
  height: 16px;
}

.upgrade-equity-modal__upgrade-right-fee-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

// 变更权益区域
.upgrade-equity-modal__changed-benefits-title {
  font-size: 14px;
  color: var(--x-warning-10);
  font-weight: 600;
  line-height: 20px;
  margin-top: 20px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.upgrade-equity-modal__changed-benefits-formula {
  display: flex;
  font-size: 12px;
  font-weight: 400;
  color: var(--x-warning-10);
  cursor: pointer;
}

.upgrade-equity-modal__changed-benefits-formula-tip {
  width: 14px;
  color: var(--x-text-1);
  margin-left: 2px;
}

.upgrade-equity-modal__changed-benefits-content {
  display: flex;
}

.upgrade-equity-modal__changed-benefits-item {
  display: inline-flex;
  background-color: var(--x-warning-1);
  padding: 8px 12px 8px 8px;
  border-radius: var(--x-radius-medium);
  margin-right: 8px;
  align-items: center;
  color: var(--x-warning-10);
}

.upgrade-equity-modal__changed-benefits-item-icon {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.upgrade-equity-modal__changed-benefits-item-number {
  font-weight: 600;
}

.upgrade-equity-modal__changed-benefits-item-number--credit {
  margin-left: 6px;
}

.upgrade-equity-modal__changed-benefits-item-number--time {
  margin: 0 4px;
}

.upgrade-equity-modal__changed-benefits-item-arrow {
  width: 10px;
  height: 12px;
  margin: 0 3px;
}

// 公式区域
.upgrade-equity-modal__formula {
  font-size: 12px;
  color: var(--x-white-1);
}

.upgrade-equity-modal__formula-description {
  display: flex;
  align-items: center;
}

.upgrade-equity-modal__formula-value {
  margin-top: 12px;
  display: flex;
  align-items: center;
}

.upgrade-equity-modal__formula-fraction {
  margin-left: 12px;
  text-align: center;
}

.upgrade-equity-modal__formula-divider {
  height: 1px;
  background: #f1f1f1;
}

// 分隔线和右侧面板
.upgrade-equity-modal__divider {
  width: 1px;
  background: var(--x-back-3);
}

.upgrade-equity-modal__right-panel {
  display: flex;
}
</style>
